import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'aid-social-media-logo',
  template: `
    <div class="aid-layout-row aid-layout-gap-32 aid-layout-align-start-center">
      <img [src]="logo" alt="ICON" height="30" width="30" />
      <div class="mat-subtitle-2">{{ value || '-' }}</div>
    </div>
  `,
  styleUrls: ['./social-media-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SocialMediaLogoComponent implements OnInit {
  @Input() value?: string;
  @Input() logo?: string;
  constructor() {}

  ngOnInit() {}
}
